import type { FileFilters } from '../types/file.types';

export const FILES_QUERY_KEYS = {
  LIST: (params: {
    page: number;
    pageSize: number;
    sortBy: string;
    sortOrder: 'asc' | 'desc';
    search: string;
    onlyMe: boolean;
    filters: FileFilters[];
  }) => [
    'files',
    params.page,
    params.pageSize,
    params.sortBy,
    params.sortOrder,
    params.search,
    params.onlyMe,
    params.filters.join(','),
  ] as const,
} as const; 